import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Profile from 'components/templates/profile';
import useUser from 'utils/useUser';

const ProfilePage = () => {
  const { userType, firstName, lastName, title, birthDate, email, phone } =
    useUser();

  const {
    user: { toggleAlerts },
  } = useDispatch();

  const { alertEmail, alertSms } = useSelector((state) => state.user);

  return (
    <Profile
      alertEmail={alertEmail}
      alertSms={alertSms}
      userType={userType}
      firstName={firstName}
      lastName={lastName}
      title={title}
      birthDate={birthDate}
      email={email}
      phone={phone}
      toggleAlerts={toggleAlerts}
    />
  );
};

export default ProfilePage;
